module.exports = __webpack_public_path__ + "static/img/cont58_01.dddca13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont58_01.jpg
// module id = Yig3
// module chunks = 0